import styled from 'styled-components';
import { PRIMARY_COLOR, PRIMARY_TEXT_COLOR } from '../../constants';
import { desktopMediaQuery } from '../../styleHelpers';
import { comeUpAnimation } from '../../components/ImageStuff/animations';
import Logo from '../../components/common/TopBar/Logo';

const TitlesSection = () => (
  <Container>
    <ContentWrapper>
      <Logo inLandingPage />
      <TitleContainer>Uncensored AI Image Generator & AI Chat</TitleContainer>

      <MainDescription>
        Browse and generate images and chat with the unfiltered AI bots on
        TheUncensored.AI
      </MainDescription>

      <StatsCard>
        <StatItem>
          <Highlight>100M+</Highlight>
          <StatText>Generations</StatText>
        </StatItem>
        <StatItem>
          <Highlight>500k+</Highlight>
          <StatText>Users</StatText>
        </StatItem>
      </StatsCard>
    </ContentWrapper>
  </Container>
);

const Container = styled.section`
  display: flex;
  justify-content: center;
  width: 93%;
  padding: 8px;
`;

const SMALLER_WIDTH_THRESHOLD = 1400;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 800px;
  margin-top: -8px;

  ${desktopMediaQuery} {
    margin-top: 80px;
    @media (max-width: ${SMALLER_WIDTH_THRESHOLD}px) {
      margin-top: 100px;
    }
  }

`;

const TitleContainer = styled.h1`
  font-weight: 600;
  font-size: 32px;
  line-height: 1.2;
  padding-left: 16px;
  padding-right: 16px;
  margin-bottom: 16px;

  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-image: linear-gradient(
    to right,
    ${PRIMARY_TEXT_COLOR} 20%,
    ${PRIMARY_COLOR} 80%
  );

  animation: ${comeUpAnimation} 0.8s ease-out forwards;
  opacity: 0;

  ${desktopMediaQuery} {
    text-align: center;
    font-size: 50px;
    margin-bottom: 8px;
    @media (max-width: ${SMALLER_WIDTH_THRESHOLD}px) {
      font-size: 40px;
      max-width: 600px;
    }
  }
`;

const MainDescription = styled.h2`
  font-size: 18px;
  font-weight: 400;
  line-height: 1.5;
  color: ${PRIMARY_TEXT_COLOR};
  margin-bottom: 16px;
  padding-left: 16px;
  padding-right: 16px;
  max-width: 600px;

  animation: ${comeUpAnimation} 1s ease-out forwards;
  opacity: 0;
  animation-delay: 0.2s;

  ${desktopMediaQuery} {
    font-size: 24px;
    @media (max-width: ${SMALLER_WIDTH_THRESHOLD}px) {
      font-size: 20px;
    }
  }
`;

const StatsCard = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 75vw;
  max-width: 600px;
  padding: 16px 24px;
  border-radius: 24px;

  animation: ${comeUpAnimation} 1.2s ease-out forwards;
  opacity: 0;
  animation-delay: 0.4s;

  ${desktopMediaQuery} {
    padding: 40px;
    @media (max-width: ${SMALLER_WIDTH_THRESHOLD}px) {
      padding: 24px;
    }
  }
`;

const StatItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 32px;

  ${desktopMediaQuery} {
    padding: 0 64px;
    @media (max-width: ${SMALLER_WIDTH_THRESHOLD}px) {
      padding: 0 32px;
    }
  }
`;

const StatText = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: ${PRIMARY_TEXT_COLOR};
  text-align: center;

  ${desktopMediaQuery} {
    font-size: 20px;
    @media (max-width: ${SMALLER_WIDTH_THRESHOLD}px) {
      font-size: 16px;
    }
  }
`;

const Highlight = styled.span`
  color: ${PRIMARY_COLOR};
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 8px;

  ${desktopMediaQuery} {
    font-size: 56px;
    @media (max-width: ${SMALLER_WIDTH_THRESHOLD}px) {
      font-size: 40px;
    }
  }
`;

export default TitlesSection;
